
module.exports =(info)=>{
    const arr = info.substring(0,57).split(' ')
    const popped = arr.pop()
    return [
        [arr.join(' ')],
        [popped + info.substring(57,info.length)]
    ]
}